module.exports = __webpack_public_path__ + "assets/img/cccd-to.svg";